import { ThirdPartyType } from "@pepper/signature-react/dist/cjs/interfaces/signature";
import { CustomSignature } from "../../AppStyledComponents";
import CustomHeader from "../../components/CustomHeader/CustomHeader";
import {
  SuccessBody,
  SuccessSubtitle,
  SuccessTitle,
} from "./SuccessStyledComponents";
import SuccessImg from "../../img/successImg.png";

const Success = () => {
  return (
    <CustomSignature>
      <CustomHeader firmaStyle={"ECO"} typeSignature={ThirdPartyType.PEPPER} />
      <SuccessBody>
        <img width={"80%"} src={SuccessImg} alt="Success" />
        <SuccessTitle>Completado con éxito</SuccessTitle>
        <SuccessSubtitle>
          ¡Enhorabuena! Tu préstamo ya está firmado. Pronto te haremos llegar la
          documentación correspondiente.
        </SuccessSubtitle>
      </SuccessBody>
    </CustomSignature>
  );
};

export default Success;
